import React from 'react';
import { useState, useEffect, useRef } from "react";
import { debounce } from 'lodash';
import IconMenu from './IconMenu';
import ServiziMenu from './ServiziMenuItem';
import NewsMenu from './NewsMenuItem';
import HomeNavItem from './HomeMenuItem';
import ContattiMenuItem from './ContattiMenuItem';

import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';

import 'bootstrap';
import './style.css';

const location_origin = typeof window !== "undefined" ? `${window.location.origin.toString()}/` : `https://www.notaio-treviso.com/`

const logo2 = 'https://www.notaio-treviso.com/logo.webp'
const logo1 = 'https://www.notaio-treviso.com/logo_tr.webp'


function NavBar () {

	const [pathname, setpathname] = useState(window.location.pathname)
	const [homeMenuOpen, setHomeMenuOpen] = useState(false)
	const [contattiMenuOpen, setContattiMenuOpen] = useState(false)
	const [serviziMenuOpen, setServiziMenuOpen] = useState(false)
	const [newsMenuOpen, setNewsMenuOpen] = useState(false)
	const [togglerClose, setTogglerClose] = useState(true)
	const [logo, setlogo] = useState(logo1)
	const [colorMenu, setColorMenu] = useState('black')
	const [colorMenuTOG, setColorMenuTOG] = useState('black')
	const [scroll, setScroll] = useState({ scrollTop: 0, scrolling: false });

	const [navClass, setNavClass] = useState('navbar navbar-b navbar-expand-md fixed-top navbar-trans');
	

	const [windowSize, setWindowSize] = useState({
		width: undefined,
		height: undefined,
	  });

	const ref = useRef();

	const navbarProps = {
		location_origin,
		homeMenuOpen,
		setHomeMenuOpen,
		pathname,
		contattiMenuOpen,
		setContattiMenuOpen,
		serviziMenuOpen,
		setServiziMenuOpen,
		newsMenuOpen,
		setNewsMenuOpen,
		togglerClose,
		setTogglerClose,
		colorMenu,
		setColorMenu,
		colorMenuTOG,
		closeAll
		};

	useOnClickOutside(ref, () => closeAll());

	useEffect(() => {
		const handleResize = debounce(() => {
		  setWindowSize({
			width: window.innerWidth,
			height: window.innerHeight,
		  });
		}, 200);
	  
		window.addEventListener("resize", handleResize);
	  
		return () => window.removeEventListener("resize", handleResize);
	  }, []);
		
	function onScroll() {
		const position = window.pageYOffset;
		if (position > scroll.scrollTop) {
		  setScroll({ scrollTop: position, scrolling: false });
		} else {
		  setScroll({ scrollTop: position, scrolling: true });
		}
	}
	  
	useEffect(() => {
		window.addEventListener("scroll", onScroll);
		
		return () => window.removeEventListener("scroll", onScroll);
	}, [scroll.scrollTop]);

	  
	function closeAll() {
		setHomeMenuOpen(false)
		setContattiMenuOpen(false)
		setServiziMenuOpen(false)
		setNewsMenuOpen(false)
	} 

	useEffect(() => {

		if (togglerClose) {
		  setlogo(logo2);
		  setColorMenu('black');
		  setNavClass('whiteBackMenu navbar navbar-b navbar-expand-md fixed-top navbar-trans navbar-reduce');
		 
		} else if (!togglerClose) {
		  setlogo(logo2);
		  setColorMenu('black');
		  setNavClass('whiteBackMenu openMediaMenu navbar navbar-b navbar-expand-md fixed-top navbar-trans navbar-reduce');
		 
		} 
	  }, [windowSize.height, togglerClose, windowSize]);
	  
	
	    
	function useOnClickOutside(ref, handler, events = ["mousedown", "touchstart"]) {
		const savedHandler = useRef(handler);
	  
		useEffect(() => {
		  savedHandler.current = handler;
		}, [handler]);
	  
		useEffect(() => {
		  function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
			  savedHandler.current(event);
			}
		  }
	  
		  events.forEach((event) => {
			document.addEventListener(event, handleClickOutside);
		  });
	  
		  return () => {
			events.forEach((event) => {
			  document.removeEventListener(event, handleClickOutside);
			});
		  };
		}, [ref, events]);
	}
	
	  
	return (
		<AppBar position="static">
			<nav className={navClass}
				style={{ display: "flow-root" }}
				id="mainNav"
				ref={ref}>
				{togglerClose && (
				<IconMenu location_origin={location_origin} iconMenu='iconMenu'/>
				)}
				<div className="container">
					<a className="navbar-brand js-scroll" href={`${location_origin}`}>
						<img
						src={togglerClose ? logo : logo2}
						title="Logo Studio Notarile Falcinelli | Notaio a Treviso"
						alt="logo"
						style={{
							maxWidth: "257px",
							filter: "drop-shadow 8px 8px 8px",
						}}
						/>
					</a>
					<button
						className={
						togglerClose ? "navbar-toggler collapsed" : "navbar-toggler"
						}
						type="button"
						onClick={() => setTogglerClose(!togglerClose)}
					>
						<span></span>
						<span></span>
						<span></span>
					</button>
					<div
					className={`navbar-collapse justify-content-end collapse${togglerClose ? '' : ' show navMenuOpen'}`}
					id="navbarDefault"
					>
						<ul className="navbar-nav" style={{ width: "max-content", alignItems : 'center' }}>
							<HomeNavItem {...navbarProps} />
							<ContattiMenuItem {...navbarProps} />
							<ServiziMenu {...navbarProps} />
							<NewsMenu {...navbarProps} />
							{!togglerClose && <IconMenu location_origin={location_origin} iconMenu='iconMenuTOG' />}
						</ul>
					</div>
				</div>
			</nav>
		</AppBar>
		
	);
}

export default NavBar;


